import React, { useState, useEffect, useRef } from 'react';
import MainPagetitle from '../../layouts/MainPagetitle';
import { Form, Modal, Button } from 'react-bootstrap';

import BannerService from '../../api/services/BannerService';
import { useNavigate, Link } from 'react-router-dom';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
import { Editor } from '@tinymce/tinymce-react'
const BannerList = () => {
    const [description, setDescription] = useState("");
    const [germandescription, setGermanDescription] = useState("");
    const editorRef = useRef(null);
    const germaneditorRef = useRef(null);
    const [isChecked, setIsChecked] = useState(false);
    const [error, setError] = useState([]);
    const [isLoading, setisloading] = useState(true);
    const [BannerData, setBannerData] = useState([]);
    const [BannerModal, setBannerModal] = useState(false);
    const navigate = useNavigate();
    useEffect(() => {
        if (localStorage.getItem("admintoken")) {

            getBannerDetails();
        }
        else {
            navigate('/')
        }
    }, []);
    const getBannerDetails = async () => {
        try {
            let bannerList = await BannerService.index().json();
            if (bannerList.status === true) {
                setBannerData(bannerList.data)
                if (bannerList.data.status === 0) {
                    setIsChecked(false)
                }
                else {
                    setIsChecked(true)
                }

                
            }
            setisloading(false);
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
            }
        }
    };
    const handleEditorChange = (content) => {
        setDescription(content);
    };

    const handleGermanEditorChange = (content) => {
        // const data = editor.getData()

        setGermanDescription(content);

    }
    const handleToggle = () => {
        setIsChecked(prevState => !prevState);
    };
    const onSubmitForm = async (event) => {
        event.preventDefault();

        try {
            if (description.length >= 150) {
                setError("Description cannot exceed 150 characters");
            }
            else if (germandescription.length >= 150) {
                setError("Description cannot exceed 150 characters");
            }
            else {


                var userData = {
                    "id": BannerData.id,
                    "description": description ? description : BannerData.description,
                    "de_description": germandescription ? germandescription : BannerData.de_description,
                    "link": event.target.link.value,
                    "status": isChecked === true ? 1 : 0,

                }


                let responseData = await BannerService.update(userData).json()
                if (responseData.status === true) {
                    setBannerModal(true)
                    setError("")
                }
            }
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
            }
        }

    };


    return (
        <>
            <MainPagetitle mainTitle="Banner" pageTitle={'Banner'} parentTitle={'Home'} />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body">
                                <form onSubmit={onSubmitForm}>
                                    <div className="col-xl-12 mb-3">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Banner Status</label>
                                        <Form.Check
                                            type="switch"
                                            id="custom-switch"
                                            label={isChecked ? 'On' : 'Off'}
                                            checked={isChecked}
                                            onChange={handleToggle}
                                        />

                                    </div>
                                    <div className="col-xl-12 mb-3">
                                        <label htmlFor="val-number" className="form-label"> English Banner Description <span className="text-danger">*</span></label>
                                        <div className="custom-ekeditor">

                                            <Editor
                                                apiKey='mzqtqwlw84qnnu5kf0a75l26z26pon7ty2tl1lw5b7u5ukf7'
                                                onInit={(_evt, editor) => editorRef.current = editor}
                                                initialValue={BannerData ? BannerData.description : ""}
                                                init={{
                                                    // height: 500,
                                                    menubar: true,
                                                    plugins: [
                                                        'advlist', 'underline', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                                                        'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                                        'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                                                    ],
                                                    toolbar: 'undo redo |underline| blocks | bold italic forecolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help',
                                                    content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                                                    setup: (editor) => {
                                                        editor.on('Change', () => {
                                                            const content = editor.getContent();
                                                            handleEditorChange(content);
                                                        });
                                                    },
                                                    readonly: false,
                                                }}


                                            />
                                        </div>

                                    </div>
                                    <div className="col-xl-12 mb-3">
                                        <label htmlFor="val-number" className="form-label"> German Banner Description <span className="text-danger">*</span></label>
                                        <div className="custom-ekeditor">

                                            <Editor
                                                apiKey='mzqtqwlw84qnnu5kf0a75l26z26pon7ty2tl1lw5b7u5ukf7'
                                                onInit={(_evt, editor) => germaneditorRef.current = editor}
                                                initialValue={BannerData ? BannerData.de_description : ""}
                                                init={{
                                                    // height: 500,
                                                    menubar: true,
                                                    plugins: [
                                                        'advlist', 'underline', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                                                        'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                                        'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                                                    ],
                                                    toolbar: 'undo redo |underline| blocks | bold italic forecolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help',
                                                    content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                                                    setup: (editor) => {
                                                        editor.on('Change', () => {
                                                            const content = editor.getContent();
                                                            handleGermanEditorChange(content);
                                                        });
                                                    },
                                                    readonly: false,
                                                }}


                                            />
                                        </div>

                                    </div>
                                    <div className="col-xl-12 mb-3">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Banner Link<span className="text-danger">*</span></label>
                                        <input type="text"
                                            name="link"
                                            className="form-control"
                                            defaultValue={
                                                BannerData.link
                                                    ? BannerData.link
                                                    : ''
                                            }
                                            id="exampleFormControlInput1" placeholder="" />
                                    </div>


                                    <div className="text-danger mb-2">{error}</div>
                                    <div>
                                        <button type="submit" className="btn btn-primary me-1">Submit</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isLoading && <LogoAnimationLoader />}
            <Modal centered className="mark-attendence" show={BannerModal}>
                <Modal.Header>
                    <Modal.Title>Update </Modal.Title>
                    <Button variant="" className="btn-close" onClick={() => setBannerModal(false)}></Button>
                </Modal.Header>
                <Modal.Body>Update Banner Successfully.</Modal.Body>
                <Modal.Footer>
                    <Link className="btn btn-primary" to={'/admin/banner'} variant="danger light" onClick={() => setBannerModal(false)}>Close</Link>
                </Modal.Footer>
            </Modal>
        </>
    )
}
export default BannerList